<template>
  <div>
    <section class="add-course-two-section" id="form-id">
      <h4 class="title text-left squiggly-line-color">
        {{ courseName }}
      </h4>
      <h5 class="heading">Create Schedule</h5>
      <div class="add-course-two-wrapper">
        <b-form
          v-if="show"
          data-vv-scope="liveSchedule"
          @submit.prevent="action('liveSchedule')"
        >
          <div class="row">
            <b-col class="col-5">
              <b-form-group
                id="input-group-file"
                label=""
                label-for="input-file"
                description=""
              >
                <div class="live-cover-image">
                  <img
                    :src="session.imageUrl"
                    alt=""
                    style="height: 170px;width:260px "
                  />
                  <b-form-file
                    id="input-file"
                    v-model="imageUrl"
                    :state="Boolean(imageUrl)"
                    accept="image/*"
                    placeholder="Choose a cover image"
                    drop-placeholder="Drop file here..."
                    v-validate="'required|image'"
                    :class="{
                      'is-invalid': errors.has('liveSchedule.Cover Image')
                    }"
                    name="Cover Image"
                    @change="uploadCoverImage"
                  ></b-form-file>
                  <!--            after choosing change placeholder to Change cover image-->
                  <b-form-invalid-feedback
                    style="display: block ;position: absolute;top: 180px; left: 0px;"
                    id="add-course-error-feedback"
                  >
                    <small>{{
                      errors.first("liveSchedule.Cover Image")
                    }}</small>
                  </b-form-invalid-feedback>
                </div>
              </b-form-group>
            </b-col>
            <b-col class="col-7">
              <b-form-group
                id="input-group-1"
                label=""
                label-for="input-1"
                description=""
                class="col-12"
              >
                <b-form-input
                  id="input-1"
                  v-model="session.name"
                  type="text"
                  required
                  placeholder="Title"
                  v-validate="
                    'required|regex:^[A-Za-z0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _-]*$'
                  "
                  :class="{
                    'is-invalid': errors.has('liveSchedule.Session Name')
                  }"
                  name="Session Name"
                ></b-form-input>
                <b-form-invalid-feedback id="add-video-error-feedback">
                  <small>{{ errors.first("liveSchedule.Session Name") }}</small>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                id="input-group-1"
                label=""
                label-for="input-1"
                description=""
                class="col-12"
              >
                <b-form-textarea
                  id="input-1"
                  v-model="session.description"
                  type="text"
                  required
                  placeholder="Description"
                  v-validate="'required|min:20|max:150'"
                  :class="{
                    'is-invalid': errors.has('liveSchedule.Session Description')
                  }"
                  name="Session Description"
                ></b-form-textarea>
                <b-form-invalid-feedback id="add-video-error-feedback">
                  <small>{{
                    errors.first("liveSchedule.Session Description")
                  }}</small>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                id="input-group-1"
                label=""
                label-for="input-1"
                description=""
                class="col-12"
              >
                <datetime
                  v-model="session.startTime"
                  type="datetime"
                  use12-hour
                  :format="options"
                  id="startDate"
                  placeholder="Start Time"
                  :min-datetime="todayDate"
                  v-validate="'required'"
                  :class="{
                    'is-invalid': errors.has('liveSchedule.Session Start Time')
                  }"
                  name="Session Start Time"
                >
                </datetime>
                <b-form-invalid-feedback
                  id="add-video-error-feedback"
                  style="display: block"
                >
                  <small>{{
                    errors.first("liveSchedule.Session Start Time")
                  }}</small>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </div>
          <property-template
            :property-keys="propertyKeys"
            :show-prop-error="showPropError"
            :show-error="showError"
            @updateProperties="updateProperties"
          />
          <div class="text-right mr-4 pr-4">
            <b-button
              pill
              size="md"
              class="pl-4 pr-4 mt-2"
              @click="action('liveSchedule')"
              :disabled="disableButton"
            >
              Add
            </b-button>
          </div>
        </b-form>
        <div class="video-list-wrapper">
          <div
            class="added-video-item"
            v-for="(session, index) in sessionList"
            :key="index"
          >
            <div class="left">
              <img style="width:200px;height: 200px" :src="session.imageUrl" />
            </div>
            <div class="right">
              <p class="title">{{ session.videoName }}</p>
              <p class="title">
                {{
                  new Date(session.startTime).toLocaleDateString(
                    "en-US",
                    options
                  )
                }}
              </p>
              <p class="description mt-2">{{ session.description }}</p>
              <div class="col-12 pl-0 pr-2">
                <div class="multi-form-list">
                  <div
                    v-for="(prop, index) in session.properties"
                    :key="index"
                    class="multi-form-list-item"
                  >
                    <div class="deets">
                      <span class="fii">{{ prop.key }} - {{ prop.value }}</span>
                      <div class="isit">
                        <span v-if="prop.forFilter">In filter</span>
                        <span v-if="prop.primaryFilter">In search</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <!--<div class="delete" @click="editVideo(session)">-->
                <!--<font-awesome-icon-->
                <!--:icon="['far', 'edit']"-->
                <!--/>-->
                <!--<span class="ml-2">Edit</span>-->
                <!--</div>-->
                <div class="delete" @click="removeSession(session)">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                  <span class="ml-2">Delete</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="button-holder" style="text-align: right">
          <b-button size="sm" pill variant="primary" @click="goToHome">
            <span>
              <font-awesome-icon icon="arrow-left"></font-awesome-icon
            ></span>
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { fileUploadApis } from "../../services/adminApis/fileUploadApis";
import { entityVideo } from "../../services/adminApis/VideoEntityApi";
import PropertyTemplate from "../components/propertyTemplate";
export default {
  name: "live-schedule",
  components: {
    PropertyTemplate,
    datetime: Datetime
  },
  data() {
    return {
      courseName: "",
      courseId: "",
      totalSession: "",
      todayDate: "",
      show: true,
      imageUrl: "",
      session: {
        name: "",
        startTime: "",
        description: "",
        imageUrl: "",
        properties: []
      },
      propertyKeys: ["Quality", "Medium of Instruction"],
      showError: false,
      showPropError: false,
      disableButton: false,
      sessionList: [],
      options: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
      }
    };
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result && this.session.properties.length > 0) {
          this.showError = false;
          this.showPropError = false;
          this.addSchedule();
        } else {
          this.showPropError = true;
          this.showError = true;
        }
      });
    },
    goToHome() {
      if (this.sessionList.length === 0) {
        this.$bvToast.toast(`Add Atleast 1 Video`, {
          title: "Add Video",
          autoHideDelay: 500,
          appendToast: true
        });
      } else {
        this.$router.push({
          path: "/admin/dashboard"
        });
      }
    },
    updateProperties(propList) {
      this.session.properties = propList;
    },
    addSchedule() {
      if (this.sessionList.length < this.totalSession) {
        let options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        };
        let ST = new Date(this.session.startTime).toLocaleDateString(
          "en-GB",
          options
        );
        // this.sessionList.push(this.session);
        const videoData = {
          videoName: this.session.name,
          videoProperties: this.session.properties,
          courseId: this.courseId,
          description: this.session.description,
          imageUrl: this.session.imageUrl,
          startTime: ST
        };
        entityVideo.addVideo(videoData).then(() => {
          this.getVideoList();
          this.resetForm();
            this.$bvToast.toast(`New Session Scheduled successfully`, {
                title: "Schedule Session",
                autoHideDelay: 500,
                appendToast: true
            });
        });
      } else {
        this.$bvToast.toast(`Scheduled Session Limit Exceeded`, {
          title: "Schedule Session",
          autoHideDelay: 500,
          appendToast: true
        });
      }
    },
    getVideoList() {
      entityVideo.getVideoByCourseId(this.$route.query.courseId).then(res => {
        this.sessionList = res.data;
      });
    },
    removeSession(session) {
      entityVideo.removeVideo(session.videoId).then(() => {
        this.getVideoList();
          this.$bvToast.toast(`Session Removed as per Request`, {
              title: "Remove Session",
              autoHideDelay: 500,
              appendToast: true
          });
      });
    },
    uploadCoverImage(event) {
      this.disableButton = true;
      const formData = new FormData();
      formData.append("document", event.target.files[0]);
      fileUploadApis.imageUpload(formData).then(res => {
        this.session.imageUrl = res.bodyText;
        this.disableButton = false;
      });
    },
    resetForm() {
      this.session = {
        name: "",
        startTime: "",
        description: "",
        imageUrl: "",
        properties: []
      };
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  mounted() {
    this.courseName = this.$route.query.courseName;
    this.courseId = this.$route.query.courseId;
    this.totalSession = this.$route.query.totalSession;
    this.getVideoList();
    var day = new Date();
    var nextDay = new Date(day);
    nextDay.setDate(day.getDate() + 1);
    this.todayDate = nextDay.toISOString();
    document.querySelector(".vdatetime-input").classList.add("form-control");
  }
};
</script>

<style lang="scss">
.live-cover-image {
  width: 100%;
  height: 170px;
  outline: dashed 1px;
  position: relative;
  .custom-file {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    max-width: 200px;
    .custom-file-input {
      width: auto;
    }
    .custom-file-label {
      border: 0;
      width: auto;
      height: auto;
      text-align: center;
      font-weight: 400;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &::after {
        display: none;
      }
    }
  }
}
</style>
